import { ArrowLeft } from 'lucide-react'
import { PageShell } from '../components/SiteChrome'

export function NotFoundPage() {
  return <PageShell compactHeader><main className="not-found"><span>404</span><h1>This connection<br />went missing.</h1><p>The page you’re looking for may have moved or never existed.</p><a className="button button--dark" href="/"><ArrowLeft size={17} /> Back home</a></main></PageShell>
}
